import React from 'react';

export default function Content({ ...props }) {
  return (
      <main id="app-content" {...props} />
  );
}